<div class="table-container">
  <p-table
    [value]="data()"
    [scrollable]="true"
    class="p-table-fixed">
    <ng-template #header>
      <tr>
        <th class="cursor-pointer w-[15rem]">
          <app-sort-header
            columnName="Grupo empresarial"
            columnKey="GroupName"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('GroupName')"
          />
        </th>
        <th class="cursor-pointer w-[15rem]">
          <app-sort-header
            columnName="Nombre empresa"
            columnKey="CompanyName"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CompanyName')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Número de registro"
            columnKey="Identification"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Identification')"
          />
        </th>
        <th class="cursor-pointer w-[18rem]">
          <app-sort-header
            columnName="Sector(es)"
            columnKey="Sectors"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Sectors')"
          />
        </th>
        <th class="cursor-pointer w-[14rem]">
          <app-sort-header
            columnName="Nombre contacto principal"
            columnKey="ContactName"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('ContactName')"
          />
        </th>
        <!-- <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Creado por"
            columnKey="CreatedBy"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CreatedBy')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Fecha de creación"
            columnKey="CreatedAt"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CreatedAt')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Modificado por"
            columnKey="UpdatedBy"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('UpdatedBy')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Fecha de modificación"
            columnKey="UpdatedAt"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('UpdatedAt')"
          />
        </th>
        <th class="w-[8rem] text-center">Usuarios asignados</th> -->
        <th class="w-[5rem] text-center">Estado</th>
        @if( UserRole.BUSSINESSMEN | notHasRole ){
          <th class="w-[8rem] text-center" pFrozenColumn alignFrozen="right">Acciones</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-business>
      <tr>
        <td>
          <app-business-logo
            [logoUrl]="business.GroupLogoUrl"
            [name]="business.GroupName"
          />
        </td>
        <td>
          <app-business-logo
            [logoUrl]="business.CompanyLogoUrl"
            [name]="business.CompanyName"
          />
        </td>
        <td>{{ business.Identification }}</td>
        <td>{{ getSectorNames(business.Sectors) }}</td>
        <td>{{ business.ContactName }}</td>
        <!-- <td>{{ business.CreatedBy }}</td>
        <td>{{ business.CreatedAt | date : 'dd/MM/yyyy' : 'UTC' }}</td>
        <td>{{ business.UpdatedBy }}</td>
        <td>{{ business.UpdatedAt | date : 'dd/MM/yyyy' : 'UTC' }}</td>
        <td class="text-center">{{ business.AssignedUsers }} / {{ business.MaxUsers }}</td> -->
        <td class="text-center">{{ business.Status === 'ENABLED' ? 'Activo' : 'Inactivo' }}</td>
        @if( UserRole.BUSSINESSMEN| notHasRole ){
          <td class="text-center" pFrozenColumn alignFrozen="right">
            <p-button type="button" variant="text" (onClick)="displayRowActions($event, business)">
              <span class="material-symbols-outlined cursor-pointer"> more_vert </span>
            </p-button>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="12">No se encontraron resultados</td>
      </tr>
    </ng-template>
  </p-table>

  <app-paginator
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    (pageChange)="pageChange.emit($event)"
  />

  <p-popover #popover (onHide)="selectedBusiness = null">
    <ng-template #content>
      <div class="flex flex-col gap-4">
        <ul class="list-none p-0 m-0 flex flex-col">
          @for (action of filteredActionsOptions; track $index) {
          <li class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
            (click)="selectOption(action)">
            <span class="font-medium">{{ action.label }}</span>
          </li>
          }
        </ul>
      </div>
    </ng-template>
  </p-popover>
</div>
